
import React, { useEffect, useState } from 'react';
import { SubscriptionPlans } from '@/components/subscription/SubscriptionPlans';
import { useAuthSession } from '@/hooks/useAuthSession';
import { Navigate } from 'react-router-dom';
import PageHeader from '@/components/layout/PageHeader';
import { BadgeIndianRupee } from 'lucide-react';
import MainLayout from '@/components/layout/MainLayout';
import { supabase } from '@/lib/supabase';
import { useAdmin } from '@/hooks/useAdmin';
import { toast } from 'sonner';

export default function Plans() {
  const { isAuthenticated, session } = useAuthSession();
  const { isAdmin } = useAdmin();
  const [isApprovedAccess, setIsApprovedAccess] = useState(false);
  const [isCheckingAccess, setIsCheckingAccess] = useState(true);
  
  useEffect(() => {
    const checkPermissions = async () => {
      if (!session?.user) {
        setIsCheckingAccess(false);
        return;
      }
      
      try {
        // Special admin check for admin@admin.com
        if (session.user.email === 'admin@admin.com') {
          console.log('Admin detected via email');
          setIsApprovedAccess(true);
          setIsCheckingAccess(false);
          return;
        }
        
        // Use check-auth-permissions function
        const { data, error } = await supabase.functions.invoke('check-auth-permissions');
        
        if (error) {
          console.error("Error checking permissions:", error);
          toast.error("Failed to verify access permissions");
        } else {
          console.log('Permission check result:', data);
          setIsApprovedAccess(data.is_allowed_access || data.is_admin);
        }
      } catch (err) {
        console.error("Error checking access:", err);
      } finally {
        setIsCheckingAccess(false);
      }
    };
    
    checkPermissions();
  }, [session]);
  
  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }
  
  return (
    <MainLayout>
      <div className="container max-w-6xl mx-auto py-8">
        <PageHeader
          title="Subscription Plans"
          description={
            isAdmin || isApprovedAccess 
              ? "You have full access to all features" 
              : "Choose the perfect plan for your preparation needs"
          }
          icon={<BadgeIndianRupee className="w-8 h-8 text-primary" />}
        />
        
        <div className="mt-8">
          <SubscriptionPlans mode="dashboard" />
        </div>
        
        <div className="mt-8 text-center text-sm text-muted-foreground">
          <p>
            *All prices are exclusive of applicable GST. GST will be added at checkout.
          </p>
        </div>
      </div>
    </MainLayout>
  );
}
